import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[CustomNumberDirective]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomNumberDirective, multi: true}]
})
export class CustomNumberDirective implements Validator {
  @Input()
  CustomNumberDirective:string;
  validate(c: FormControl): {[key: string]: any} {
      let v:string = c.value;
      return (v.length>=3||v=="-1")? {"CustomNumberDirective": true} : null;
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Directives/CustomNumberDirective.ts